/* eslint-disable no-unused-expressions */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import Cookie from 'cookies-js';
import { withRouter } from 'react-router-dom';

import {
  UserOnTrackInvestmentCard,
  UserUnTrackInvestmentCard,
} from '../../commons/index';

/**
 * @class MyInvestmentPlans
 */
class MyInvestmentPlans extends Component {
  setLinkOnInvest = () => {
    Cookie.set('investLink', '/invest-plan');
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      fixTipInvestObj,
      mtLipInvestObj,
      history
    } = this.props;

    const checkFixTipInvestObj = !fixTipInvestObj ? [] : fixTipInvestObj;

    const checkMtLipInvestObj = !mtLipInvestObj === 0 ? [] : mtLipInvestObj;

    const mainInvestArray = checkFixTipInvestObj.concat(checkMtLipInvestObj);

    const userInvestments = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="investment_upper_part">
          <div className="investment_upper_part_title">
            <div className="first_child">
              <h4>
                My Invesments
              </h4>
              <p>
                Select your invesments plan of interest
              </p>
            </div>

            <div className="second_child">
              <div className="second_child_icon main">
                <i className="fas fa-search main" />
              </div>
              <div className="second_child_input main">
                <input type="text" name="" id="" placeholder="Search...." />
              </div>
              <div className="second_child_filter main my_savinngs_header_addNewLink">

                <p>
                  <a href="/invest-plan"
                    onClick={this.setLinkOnInvest}
                  >
                    <span>
                            +
                    </span>
                        Add new
                  </a>
                </p>
              </div>

            </div>
          </div>


          <div className="savings_plan_for_interest">
            {
              mainInvestArray.length === 0 ? (
                <div className="text-center">
                  <Loader
                    type="Circles"
                    color="#00C177"
                    height="100"
                    width="100"
                  />
                </div>
              ) : (
                mainInvestArray.map(invest => (invest.title === 'fixTip' ? (
                  (
                    <UserOnTrackInvestmentCard
                      amount={invest.amount}
                      status={invest.status}
                      maturityDate={invest.maturityDate}
                      title={invest.title}
                      tenorInDays={invest.tenorInDays}
                      dateCreated={invest.dateCreated}
                      investmentId={invest.id}
                      actionType="fixTipAction"
                    />
                  )
                ) : (
                  <UserUnTrackInvestmentCard
                    amount={invest.amount}
                    status={invest.status}
                    tenorInDays={invest.tenorInDays}
                    title={invest.title}
                    dateCreated={invest.dateCreated}
                    investmentId={invest.id}
                    actionType="mtLipAction"
                  />
                )))
              )
            }
          </div>

        </div>
      </section>
    );
    return (
      <div>
        {userInvestments}
      </div>
    );
  }
}

MyInvestmentPlans.propTypes = {
  fixTipInvestObj: PropTypes.any,
  mtLipInvestObj: PropTypes.func,
};

export default withRouter(MyInvestmentPlans);
